// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nowrap[data-v-1c99ca13] {\n  white-space: nowrap;\n}\n.table-summary[data-v-1c99ca13] {\n  background-color: beige;\n}\n", ""]);
// Exports
module.exports = exports;
